import { computed, ref, watchEffect } from 'vue';
import { useStore } from 'vuex-composition-helpers';

class CabecalhoService {
    setup() {
        const store = useStore()
        const dadosAtendimento = computed(() => store.state.dadosAtendimento)
        const protocolo = ref('')
        const placa = ref('')

        watchEffect(() => {
            if (dadosAtendimento.value) {
                protocolo.value = dadosAtendimento.value.protocolo
                placa.value = dadosAtendimento.value.placa
            }
        })

        return { protocolo, placa }
    }
}

export default new CabecalhoService()